import { Component, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RegistrationService } from './registration/registration.service';
import { DataService } from './shared/service/dataService';
import { NotificationService } from './shared/service/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  private monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  registrationDates: string = '';
  eventDates: string = '';
  isOrgConfigsLoaded: boolean = false;

  constructor(
    private registrationService: RegistrationService,
    private notificationService: NotificationService,
    private dataService: DataService,
    private titleService: Title,
    private renderer: Renderer2) { }

  ngOnInit(): void {
    this.setFavicon('assets/hill-district.png');
    this.registrationService.getOrgConfigsByAbbreviation('hill')
      .then(response => {
        this.dataService.orgConfigs = response;
        this.titleService.setTitle(response.events.eventName);
        this.registrationDates = this.formatEventDates(response.events.registrationStart, response.events.registrationEnd);
        this.eventDates = this.formatEventDates(response.events.scheduleStart, response.events.scheduleEnd);
        this.isOrgConfigsLoaded = true;
      })
      .catch(err => {
        this.notificationService.error(err);
      });
  }

  private setFavicon(url: string) {
    const link: HTMLLinkElement = this.renderer.selectRootElement('link[rel="icon"]', true);
    if (link) {
      link.href = url;
    }
  }

  formatEventDates(startDateStr: string, endDateStr: string): string {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    const startDay = startDate.getDate();
    const startMonth = this.getMonthName(startDate.getMonth());

    const endDay = endDate.getDate();
    const endMonth = this.getMonthName(endDate.getMonth());

    const year = endDate.getFullYear(); // Assuming the year is the same for both dates

    const startSuffix = this.getDaySuffix(startDay);
    const endSuffix = this.getDaySuffix(endDay);

    return `${startMonth} ${startDay}<sup>${startSuffix}</sup> - ${endMonth} ${endDay}<sup>${endSuffix}</sup>, ${year}`;
  }

  private getMonthName(month: number): string {
    return this.monthNames[month];
  }

  private getDaySuffix(day: number): string {
    if (day > 3 && day < 21) return 'th'; // Special case for teens
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

}